import { render, staticRenderFns } from "./VisitTips.vue?vue&type=template&id=6424391b&scoped=true&"
import script from "./VisitTips.vue?vue&type=script&lang=js&"
export * from "./VisitTips.vue?vue&type=script&lang=js&"
import style0 from "./VisitTips.vue?vue&type=style&index=0&id=6424391b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6424391b",
  null
  
)

export default component.exports